<template>
  <div class="main">
      <div class="info-group">
        <div class="info-item ">
          <div class="pair-content">
            <div class="item-content">
              <my-input-form :form="{
                  id:company.id,
                  name:'name',
                  title:'Название:',
                  value:company.name,
                  model
                }"
                class="info-item liner">
                Название: 
              </my-input-form>
              <my-input-form :form="{
                  id:company.id,
                  name:'director',
                  title:'Директор:',
                  value:company.director,
                  model
                }">
                Директор: 
              </my-input-form>
              <my-input-form :form="{
                  id:company.id,
                  name:'ogrn',
                  title:'ОГРН:',
                  value:company.ogrn,
                  model
                }">
                ОГРН: 
              </my-input-form>
              <my-input-form :form="{
                  id:company.id,
                  name:'inn',
                  title:'ИНН:',
                  value:company.inn,
                  model
                }">
                ИНН: 
              </my-input-form>
              <p class="info-item liner">Черный список: {{ company.black_list ? '📛' : '✅' }}</p>
              <p class="info-item liner">Клиентский черный список: {{ company.client_black_list ? '📛' : '✅' }}</p>

              <div class="add-recommendation">
                <button @click="showRegisterForm = !showRegisterForm">Добавить рекомендацию</button>
                <div class="mr-t-5" v-if="showRegisterForm">
                  <Recommendation class="register" :companyId="company.id" />
                </div>
              </div>
            </div>

            <div class="item-tables">
                <div class="table-data">
                  <p>Мастер создания исполнителя</p>
                  <WizardExecutor :companyId="company.id" :company="company" />
                </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-group">
        <div class="info-item">
          <div class="pair-content">
            <div class="item-content">
              <h3 class="group-title">ATI</h3>
                <p class="info-item liner">ОГРН:
                  <span :class="company.ati_company_orgn_num==company.ogrn ? 'bg-success' : 'bg-denied'">{{company.ati_company_orgn_num}}</span></p>
                <p class="info-item liner">Позиция в городе: {{company.ati_company_position_in_city}} </p>
                <p class="info-item liner">Позиция в регионе: {{company.ati_company_position_in_country}} </p>
                <p class="info-item liner"
                v-if="company.ati_company_tf_firm_color === 'Green' ">Светофор: 🟢 </p>
                <p class="info-item liner"
                v-else-if="company.ati_company_tf_firm_color === 'Yellow' ">Светофор: 🟡 </p>
                <p class="info-item liner" v-else>Светофор: 🔴 </p>
            </div>
            <div class="item-content">
              <h3 class="group-title">Dadata</h3>
              <p class="info-item liner">ОГРН: 
                <span :class="company.dadata_inn_ogrn==company.ogrn ? 'bg-success' : 'bg-denied'">{{company.dadata_inn_ogrn}}</span>
              </p>
              <p class="info-item liner">Статус ИНН: 
                <span :class="company.dadata_inn_status=='Действующая' ? 'bg-success' : 'bg-denied'">{{company.dadata_inn_status}}</span>
              </p>
              <p class="info-item liner">Директор: {{company.dadata_inn_director}} </p>
              <p class="info-item liner" v-if="company.dadata_inn_liquidation_date">Дата ликвидации:{{spliter(company.dadata_inn_liquidation_date)}} </p>
              <p class="info-item liner"
                v-if="company.dadata_inn_registration_date">
                Дата регистрации:
                <span :class="is_valid ? 'bg-success' : 'bg-denied'">{{ spliter(company.dadata_inn_registration_date) }}
                </span> 
              </p>
              <p class="info-item liner">Комментарии: {{company.dadata_inn_status_description}}
              </p>
            </div>
          </div> 
        </div>
      </div>
      <div class="footer">
        <div class="footer-content">
              <p class="info-item">Проверка ATI: {{ company.is_ati_company ? '✅' : '❌' }}</p>
              <p class="info-item">Проверка Dadata: {{ company.is_dadata_inn ? '✅' : '❌' }}</p>
        </div>
      </div>
  </div>
</template>


<script>
import { useForm,useFormat } from '@/hooks/form'
import { dateValid } from '@/hooks/formatDate.js'
import { ref,computed,reactive,onBeforeUpdate } from 'vue'
import Recommendation from '@/components/Recommendation.vue'
import ManagerForm from '@/components/forms/ManagerForm'
import DriverForm from '@/components/forms/DriverForm'
import CarForm from '@/components/forms/CarForm'
import WizardExecutor from '@/components/forms/WizardExecutorForm'


export default {
  components:{
    Recommendation,
    ManagerForm,
    DriverForm,
    CarForm,
    WizardExecutor
  },
  name: 'CompanyDetailTadle',
  props:['company',"min_corp_reg_year"],
  setup(props){
    
    const model = 'companies'
    const showRegisterForm = ref(false);
    const tableItem = ref('manager')

    const changeTable = name =>{
      tableItem.value = name
    }

    const spliter = date =>{
      return date.split(' ')[0]
    }

    const is_valid = date=>{
      return dateValid(date,props.min_corp_reg_year)
    }

    return {
      tableItem,
      model,
      spliter,
      is_valid,
      showRegisterForm,
      changeTable
    }
  }
}
</script>

<style scoped>

.main{
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
}

.item-content{
  max-width: 250px;
  width: 100%;
}

.pair-content{
  display: flex;
  justify-content: space-around;
}

.footer{
  display: flex;
  justify-content: space-around;
  align-items: center; 
  margin-top: 50px;
}
.footer-content{
  margin: 0;
  width: 50%;
  display: flex;
  justify-content: space-around;
}

.liner{
  border-bottom: 1px solid rgba(230,194,118, 1) ;
  padding-bottom: 3px;
}

.bg-success{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(152,236,131,0.6);
}

.bg-denied{
  border-radius: 2px;
  padding: 2px;
  background-color: rgba(182,0,24,0.4);
}
.add-recommendation{
/*  min-width: 300px;*/
}
button {
  margin: 25px auto;
  padding: 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.item-tables{
  max-width: 400px;
  padding: 0 10px;
  flex-grow: 1;
}

.model-button{
  display: flex;
  justify-content: space-around;
}

</style>
